import { render, staticRenderFns } from "./SortFiles.vue?vue&type=template&id=ecb1ad4c&"
import script from "./SortFiles.vue?vue&type=script&lang=js&"
export * from "./SortFiles.vue?vue&type=script&lang=js&"
import style0 from "./SortFiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports